import React, { useEffect, useState } from 'react';
import { useForm, Controller } from 'react-hook-form';
import {
  Box,
  Button,
  Snackbar,
  TextField,
  Typography,
  Switch,
  Grid,
  FormControlLabel,
  Autocomplete,
  Paper,
  Divider
} from '@mui/material';
import { useConfigDataService } from '../../services/ConfigDataService';
import { useEmployeeService } from "../../services/EmployeeService";

const AssignLocationForm = ({ empID, onSubmit, onClose }) => {
  const { fetchLocationMaster } = useConfigDataService();
  const { AssignLocation } = useEmployeeService();

  const { handleSubmit, control, watch } = useForm({
    defaultValues: {
      UseDefault: true,
      GeoRadius: 0.1,
      AmpersandMappingId: 0,
      MappingId: 0,
      UserId: 0,
      EmployeeId: empID || '',
      DerivedLocationId: 0,
      LocationType: 0,
      LocationObject: null
    }
  });

  const [locations, setLocations] = useState([]);
  const [saving, setSaving] = useState(false);
  const [snackbarOpen, setSnackbarOpen] = useState(false);

  const useDefault = watch('UseDefault');
  const selectedLocation = watch('LocationObject');

  useEffect(() => {
    fetchLocationMaster().then(data => setLocations(data || []));
  }, [fetchLocationMaster]);

  const handleFormSubmit = async (data) => {
    setSaving(true);
    const now = new Date().toISOString();
    const payload = {
      ...data,
      DerivedLocationId: data.LocationObject?.AmpersandLocationId || 0,
      UpdatedOn: now,
      AssignedDate: now,
    };
    delete payload.LocationObject;
    const result = await AssignLocation(payload);
    console.log("Assignment successful:", result);
    setSaving(false);
    setSnackbarOpen(true);
    onSubmit();
  };

  return (
    <Box sx={{ px: 0, pb: 2, pt: 0, height: 'auto', overflowY: 'auto', }}>
      <form onSubmit={handleSubmit(handleFormSubmit)}>
        <Grid container spacing={2} sx={{ mt: 1 }} alignItems="center">
          <Grid item size={4}>
            <Controller
              name="LocationObject"
              control={control}
              rules={{ required: true }}
              render={({ field }) => (
                <Autocomplete
                  options={locations}
                  getOptionLabel={(option) => `${option.Description || ''} - ${option.StateName || ''}`}
                  isOptionEqualToValue={(option, value) => option.AmpersandLocationId === value?.AmpersandLocationId}
                  onChange={(_, value) => field.onChange(value)}
                  value={field.value}
                  renderInput={(params) => (
                    <TextField {...params} label="Select Location" required fullWidth size="small" />
                  )}
                />
              )}
            />
          </Grid>

          <Grid item size={2.5}>
            <Controller
              name="UseDefault"
              control={control}
              render={({ field }) => (
                <FormControlLabel
                  control={<Switch {...field} checked={field.value} />}
                  label="Use Default Radius"
                />
              )}
            />
          </Grid>

          {!useDefault && (
            <Grid item size={1.5}>
              <Controller
                name="GeoRadius"
                control={control}
                rules={{ required: true, min: 0.1 }}
                render={({ field }) => (
                  <TextField
                    {...field}
                    type="number"
                    label="Geo Radius (km)"
                    fullWidth
                    size="small"
                    inputProps={{ step: 0.1, min: 0.1 }}
                    required
                  />
                )}
              />
            </Grid>
          )}
            <Grid item size={1.5}>

           <Button
              type="submit"
              variant="contained"
              fullWidth
              disabled={saving}
              size="small"
              sx={{ py: 0.5, px: 1, minHeight: '30px', fontSize: '0.75rem' }}
            >
              {saving ? 'Assigning...' : 'Assign'}
            </Button>

          </Grid>
             <Grid item size={1.5}>
            <Button
                type="button"
                variant="contained"
                onClick={onClose}
                fullWidth
                disabled={saving}
                size="small"
                sx={{ py: 0.5, px: 1, minHeight: '30px', fontSize: '0.75rem' }}
              >
                Close
              </Button>

          </Grid>
          {selectedLocation && (
            <Grid item size={12}>
              <Paper variant="outlined" sx={{ p: 1.5,  boxShadow: 1, mt: 1 }}>
                    <Typography variant="body2">
                        <strong>📌 Code:</strong> {selectedLocation.LocationCodeC1} &nbsp;&nbsp;
                        <strong>📍 Latitude:</strong> {selectedLocation.Latitude} &nbsp;&nbsp;
                        <strong>📍 Longitude:</strong> {selectedLocation.Longitude} &nbsp;&nbsp;
                        <strong>🧭 Radius:</strong> {selectedLocation.Radius} km &nbsp;&nbsp;
                        <strong>🏷️ Location:</strong> {selectedLocation.Description} &nbsp;&nbsp;
                        <strong>🏙️ City:</strong> {selectedLocation.CityName} &nbsp;&nbsp;
                        <strong>🌐 State:</strong> {selectedLocation.StateName}
                    </Typography>
                    </Paper>

            </Grid>
          )}

          
        </Grid>

        <Snackbar
          open={snackbarOpen}
          autoHideDuration={3000}
          onClose={() => setSnackbarOpen(false)}
          message="Location Assigned Successfully"
        />
      </form>
    </Box>
  );
};

export default AssignLocationForm;
